import { Voice, type VoiceJson } from "./Voice";
import { LanguageCollection } from "./LanguageCollection";
import type { SpeechService } from "./SpeechService";

export interface GoogleVoiceJson extends VoiceJson {
	replacementVoice : string | undefined;
  replacementDate : Date | undefined;
  replaced : boolean;
}

export class GoogleVoice extends Voice {
	replacementVoiceName : string | undefined;
  replacementDate : Date | undefined;
  replaced : boolean;

	constructor(
		json: GoogleVoiceJson,
		allLanguages: LanguageCollection,
		speechService: SpeechService
	  ) {
		super(json, allLanguages, speechService);
		this.replaced = json.replaced;
    if (json.replacementDate) {
		  this.replacementDate = new Date(json.replacementDate);
    }
		this.replacementVoiceName = json.replacementVoice;
	}

  getReplacementVoice() : GoogleVoice | undefined {
    if (this.replacementVoiceName) {
      return this.speechService.getVoiceByName(this.replacementVoiceName) as GoogleVoice;
    }
    return undefined;
  }
}